import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Eye, MapPin } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { toast } from '../hooks/use-toast';

const ListingCard = ({ listing }) => {
  const navigate = useNavigate();
  const [isLiked, setIsLiked] = React.useState(false);

  const handleLike = (e) => {
    e.stopPropagation();
    setIsLiked(!isLiked);
    toast({
      title: isLiked ? 'Removed from favorites' : 'Added to favorites',
      description: listing.title,
    });
  };

  return (
    <Card
      onClick={() => navigate(`/listing/${listing.id}`)}
      className="group cursor-pointer overflow-hidden hover:shadow-xl transition-all duration-300 border-gray-200"
    >
      {/* Image Container */}
      <div className="relative overflow-hidden aspect-square bg-gray-100">
        <img
          src={listing.image}
          alt={listing.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {/* Condition Badge */}
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-gray-700 shadow-sm">
            {listing.condition}
          </span>
        </div>
        {/* Like Button */}
        <Button
          onClick={handleLike}
          variant="ghost"
          size="icon"
          className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm hover:bg-white rounded-full shadow-sm"
        >
          <Heart
            className={`w-5 h-5 transition-colors ${
              isLiked ? 'fill-red-500 text-red-500' : 'text-gray-600'
            }`}
          />
        </Button>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-semibold text-gray-900 line-clamp-2 mb-2 group-hover:text-red-500 transition-colors">
          {listing.title}
        </h3>

        <div className="flex items-center justify-between mb-3">
          <span className="text-2xl font-bold text-red-500">${listing.price}</span>
        </div>

        {/* Location and Stats */}
        <div className="flex items-center justify-between text-sm text-gray-500">
          <div className="flex items-center space-x-1">
            <MapPin className="w-4 h-4" />
            <span>{listing.location}</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-1">
              <Eye className="w-4 h-4" />
              <span>{listing.views}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Heart className="w-4 h-4" />
              <span>{listing.likes}</span>
            </div>
          </div>
        </div>

        {/* Seller Info */}
        <div className="flex items-center space-x-2 mt-3 pt-3 border-t">
          <img
            src={listing.sellerAvatar}
            alt={listing.sellerName}
            className="w-6 h-6 rounded-full"
          />
          <span className="text-sm text-gray-600">{listing.sellerName}</span>
          <span className="text-xs text-yellow-600">★ {listing.sellerRating}</span>
        </div>
      </div>
    </Card>
  );
};

export default ListingCard;
